import styled from 'styled-components';

export const StyledClearButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledIconClear = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;
  font-size: 10px;
  display: flex;
  align-items: center;
  gap: 5px;
  position: absolute;
  top: 30px;
  right: 10px;
`;
